
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.5 24a.5.5 0 01-.5-.5V.5a.5.5 0 011 0v23a.5.5 0 01-.5.5z"}}),_c('path',{attrs:{"d":"M23.5 24H.5a.5.5 0 010-1h23a.5.5 0 010 1zM7.18 22H2.5a.5.5 0 01-.5-.5v-10a.5.5 0 01.5-.5h4.68a.5.5 0 01.5.5v10a.5.5 0 01-.5.5zM3 21h3.68v-9H3zm19.5 1h-4.68a.5.5 0 01-.5-.5v-20a.5.5 0 01.5-.5h4.68a.5.5 0 01.5.5v20a.5.5 0 01-.5.5zm-4.18-1H22V2h-3.68zm-3.58 1h-4.68a.5.5 0 01-.5-.5V6.93a.5.5 0 01.5-.5h4.68a.5.5 0 01.5.5V21.5a.5.5 0 01-.5.5zm-4.18-1h3.68V7.43h-3.68z"}})])
          )
        }
      }
    